import { ActionTree } from "vuex";
import axios from "axios";
import { RootState } from "@/store/types";
import {
  StatisticState,
  MailNotifyGroupFilterParams,
  DetailFilterParams,
} from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  getMailNotifyStatisticGroup: ({ commit, dispatch }, data: MailNotifyGroupFilterParams) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/group/mail_notify",
        params: data,
      })
        .then((resp) => {
          commit("setMailNotifyStaticGroup", resp.data.messages);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportMailNotifyStatisticGroup: ({ commit, dispatch }, data: MailNotifyGroupFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/group/mail_notify/export",
        params: data,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getMailNotifyStatisticDetail: ({ commit, dispatch }, data: DetailFilterParams) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/detail/mail_notify",
        params: data,
      })
        .then((resp) => {
          let messages = resp.data?.messages ?? [];
          if (data.page_number > 1) {
            commit("pushMailNotifyStaticDetail", messages);
          } else {
            commit("setMailNotifyStaticDetail", messages);
          }
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportMailNotifyStatisticDetail: ({ commit, dispatch }, data: MailNotifyGroupFilterParams) => {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/detail/mail_notify/export",
        params: data,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getMailNotifyStatisticDetailInfo: ({ commit, dispatch }, id: string) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        url: "/stats-api/detail/mail_notify/" + id.replace(/#/g, "%23"),
      })
        .then((resp) => {
          let messageItem = resp.data;
          resolve(messageItem);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  resendMailNotifyMessage: ({ commit, dispatch }, id: string) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/acapi/tools/mail_notify/resend',
        data: {message_ids: [id]}
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
};
